<template>
  <transition name="modal">
    <div class="modal--backdrop" v-if="showModal">
      <div class="modal--container">
        <div class="modal--cross" @click="close"></div>
        <div class="modal-header--container">
          <h1 class="modal-header">{{title}}</h1>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
  @import "~sass/_config.scss";
  @import "~sass/mixins/_media-query.scss";
  @import "~sass/_variables.scss";
  .modal--container {
    transition: height 1s;
    z-index: 1010;
    width: 900px;
    height: 560px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px $col-neutral--5;
    background-color: $white;
    overflow: auto;
     @include maxq(tablet) {
      height: unset;
    }
  }
  .modal-enter-active, .modal-leave-active {
    transition: opacity .5s
  }
  .modal-enter, .modal-leave-to {
    opacity: 0
  }

  .modal-header--container {
    display: flex;
    flex: 1;
    padding-top: 60px;
    padding-bottom: 40px;
    justify-content: center;
    text-align: center;
  }
  .modal-header{
    font-size: 34px;
    font-weight: 600;
    @include maxq(tablet) {
      font-size: 26px;
    }
  }
  .modal--backdrop {
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.8);
  }
  .modal--cross {
    position: absolute;
    width: 26px;
    height: 26px;
    padding: 10px;
    top: 15px;
    right: 15px;
    cursor: pointer;

    &::before,
    &::after {
      content: "";
      display: flex;
      width: 20px;
      height: 2px;
      position: absolute;
      left: 3px;
      top: 12px;
      background: #75746b;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }

    &:hover {
      &::before,
      &::after {
        background: #000000;
      }
    }
  }
</style>
<script>

export default {
		props: {
			title: {
				type: String,
				default: ''
			},
    },
    data() {
        return {
            showModal: true,
        };
    },
    methods: {
      toggleModal () {
                this.showModal = !this.showModal;
            },
            close () {
                this.showModal = false;
            }
    }
}
</script>